import { getTabTemplateId } from '../../turboLive/push/overview/handlers';
import { getTabsForTournament$, isInfocentreTemplatesLoaded$ } from '../subs';
import { useEffect, useState } from 'react';
import { useReframe } from 'nike-re-framejs';

export const useIsBetradarWidgetAvailable = sportEvent => {
    const derefSub = useReframe();
    const [templates, setTemplates] = useState(undefined);
    const templateId = getTabTemplateId(sportEvent);
    const infoLoaded = derefSub(isInfocentreTemplatesLoaded$);

    useEffect(() => {
        if (infoLoaded && templateId) {
            const templateData = derefSub(getTabsForTournament$(templateId));

            if (!templateData) {
                setTemplates(null);
            }

            setTemplates(templateData);
        }
    }, [derefSub, infoLoaded, templateId]);

    return templates;
};
